import { inject, Injectable } from '@angular/core';

import { environment } from '@customer-portal/environments';

import { BlobTranslationStrategy } from './strategies/blob-translation-strategy';
import { LocalTranslationStrategy } from './strategies/local-translation-strategy';
import { TranslationLoadingStrategy } from './strategies/translation-loading-strategy.interface';

@Injectable({ providedIn: 'root' })
export class TranslationStrategyFactory {
  private localStrategy = inject(LocalTranslationStrategy);
  private blobStrategy = inject(BlobTranslationStrategy);

  getStrategy(): TranslationLoadingStrategy {
    return environment.translation?.useLocalTranslations
      ? this.localStrategy
      : this.blobStrategy;
  }
}
